import { useFetch, buildURI } from '@hn-front/utils';
import { SKILLS_API } from '../constants/routes';
export var useStudentSkills = function (_a) {
    var studentId = _a.studentId, domainId = _a.domainId;
    return useFetch(buildURI(SKILLS_API.studentSkills, {
        pathParams: { studentId: studentId },
        filterQuery: { domainId: domainId },
    }), { isCache: false });
};
